import generateUUID from 'syf-js-utilities/helpers/generateUUID';
/**
 * generated once on app load, then is the same forever
 */
export var staticID = "dc".concat(generateUUID().substring(0, 8));
/**
 * @returns unique string every time it is called
 */
export var uniqueID = function () { return "dc".concat(generateUUID().substring(0, 8)); };
/**
 * creates a static ID that is account-specific,
 * so two accounts on the same flow will not have the same trackingId
 *
 * @param seed a static string that was already generated
 * @param accountId ties account to tracking id
 * @returns string that combines these strings
 */
export var staticTrackingId = uniqueID();
export var getStaticIdFromSeed = function (seed, accountId) {
    // seed must be 10char
    var seedCharsNeeded = 10 - seed.length;
    var extraSeed = staticID.substring(2, 2 + seedCharsNeeded);
    var acct = (accountId === null || accountId === void 0 ? void 0 : accountId.substring(0, 4)) || '';
    var charsNeeded = 10 - acct.length;
    var seedSubstring = seed.substring(0, charsNeeded);
    return "".concat(seedSubstring).concat(extraSeed).concat(acct);
};
//# sourceMappingURL=trackingId.js.map